import React from "react";
import { Headset } from "lucide-react";
import { useIsSmallScreen } from "hooks/useDeviceType";
import useModalStore from "zustandStores/useModalStore";
import LogService from "services/LogService";
import NavEvents from "utils/Events/navEvents";
import { JhText } from "Tailwind/components/design-packages/textPackage";
import { modalStateValues } from "services/constants";
import { useContactSalesABTest } from "hooks/useABTest";
import useUserProfileStore from "zustandStores/userProfileStore";

export interface CustomerSupportProps {
  className?: string;
}

const CustomerSupport: React.FC<CustomerSupportProps> = ({
  className = ""
}) => {
  const isSmallScreen = useIsSmallScreen();
  const { shouldShowV2Form } = useContactSalesABTest();
  const { setModalData } = useModalStore(state => ({
    setModalData: state.setModalData
  }));
  const { profileData } = useUserProfileStore();
  const recruiter_status = profileData?.verification_status || "";
  const recVerifiedStatus = [
    "VERIFIED_REPEAT",
    "VERIFIED_NON_REPEAT",
    "VERIFIED"
  ];
  const isVerified = recVerifiedStatus.includes(recruiter_status);

  const handleSupportClick = () => {
    if (shouldShowV2Form) {
      LogService.log(NavEvents.CONTACT_SALES_CLICKED_V2, { src: "header" });
    } else {
      LogService.log(NavEvents.CONTACT_SALES_CLICKED, { src: "header" });
    }
    setModalData({
      state: modalStateValues.open,
      type: "CONTACT_SALES_MODAL",
      data: { src: "header" }
    });
  };
  // if not verified, don't show the button
  if (!isVerified) return null;
  return (
    <div className={`relative ${className}`}>
      <button
        onClick={handleSupportClick}
        className="flex items-center rounded-full border h-9 w-9 justify-center 
           transition-all duration-200 ease-in-out
          group overflow-hidden md:hover:w-auto md:hover:px-4 md:hover:py-2 bg-white"
      >
        {/* Icon Container */}
        <div className="flex items-center justify-center transition-colors duration-200">
          <Headset
            color="var(--foreground)"
            className="h-4 w-4 flex-shrink-0"
          />
        </div>

        {/* Text that appears on hover - only on desktop */}
        <JhText
          variant="subtitle4"
          color="foreground"
          className={`
            whitespace-nowrap transition-all duration-200
            ${
              isSmallScreen
                ? "hidden"
                : "w-0 opacity-0 md:group-hover:w-auto md:group-hover:opacity-100 md:group-hover:ml-2 bg-white"
            }
          `}
        >
          Contact sales
        </JhText>
      </button>
    </div>
  );
};

export default CustomerSupport;
